<wk-icon-chevron-up-sprite-pds3 />
<wk-icon-chevron-down-sprite-pds3 />
<wk-icon-filled-info-sprite-pds3 />

@if (cardViewService.currentViewDisplayMode === "Kanban") {
    <div class="wk-header-tabs wk-header-tabs--drop-zones" [class.dragging]="dragging()">
        <wk-drop-list
            groupId="cardStatuses"
            id="drop_list_status_not_started"
            class="wk-header-tab wk-header-tab--item wk-drop-list--dashed"
            [cdkDropListSortingDisabled]="true"
            [cdkDropListDisabled]="!notStartedStatus() || disabledDropListIds().has(notStartedStatus()?.Id)"
            (drop)="onDrop($event, notStartedStatus()?.Id)"
        >
            {{ "Dashboard.NotStarted" | translate }}
        </wk-drop-list>
        <wk-drop-list
            groupId="cardStatuses"
            [id]="'drop_list_status_active'"
            class="wk-header-tab wk-header-tab--item wk-drop-list--dashed"
            [cdkDropListSortingDisabled]="true"
            [cdkDropListDisabled]="!activeStatus() || disabledDropListIds().has(activeStatus()?.Id)"
            (drop)="onDrop($event, activeStatus()?.Id)"
        >
            {{ "Dashboard.Active" | translate }}
        </wk-drop-list>
        <wk-drop-list
            groupId="cardStatuses"
            id="drop_list_status_completed"
            class="wk-header-tab wk-header-tab--item wk-drop-list--dashed"
            [cdkDropListSortingDisabled]="true"
            [cdkDropListDisabled]="!completedStatus() || disabledDropListIds().has(completedStatus()?.Id)"
            (drop)="onDrop($event, completedStatus()?.Id)"
        >
            {{ "Dashboard.Completed" | translate }}
        </wk-drop-list>
    </div>
}
<div class="wk-header-tabs" [class.dragging]="cardViewService.currentViewDisplayMode === 'Kanban' && dragging()">
    <div
        [class.wk-header-tab--selected]="cardViewService.currentViewType === 'notStarted'"
        class="wk-header-tab wk-header-tab--item"
        [routerLink]="[currentDashboard?.Id, 'not-started']"
    >
        <span>{{ "Dashboard.NotStarted" | translate }} ({{ currentCounters.notStarted }})</span>
        <div class="wk-header-tab-clickable-chevron">
            @if (cardViewService.currentViewType === "notStarted") {
                <icon-pds3 (click)="toggleStatsVisible()" [name]="statsVisible ? 'wk-icon-chevron-up' : 'wk-icon-chevron-down'" />
            }
        </div>
    </div>
    <div
        [class.wk-header-tab--selected]="cardViewService.currentViewType === 'active'"
        class="wk-header-tab wk-header-tab--item"
        [routerLink]="[currentDashboard?.Id, 'active']"
    >
        <span>{{ "Dashboard.Active" | translate }} ({{ currentCounters.active }})</span>
        <div class="wk-header-tab-clickable-chevron">
            @if (cardViewService.currentViewType === "active") {
                <icon-pds3 (click)="toggleStatsVisible()" [name]="statsVisible ? 'wk-icon-chevron-up' : 'wk-icon-chevron-down'" />
            }
        </div>
    </div>
    <div
        [class.wk-header-tab--selected]="cardViewService.currentViewType === 'completed'"
        class="wk-header-tab wk-header-tab--item"
        [routerLink]="[currentDashboard?.Id, 'completed']"
    >
        <span>{{ "Dashboard.Completed" | translate }} ({{ currentCounters.completed }})</span>
        <div class="wk-header-tab-clickable-chevron">
            @if (cardViewService.currentViewType === "completed") {
                <icon-pds3 (click)="toggleStatsVisible()" [name]="statsVisible ? 'wk-icon-chevron-up' : 'wk-icon-chevron-down'" />
            }
        </div>
    </div>
    <div
        [class.wk-header-tab--selected]="cardViewService.currentViewType === 'all'"
        class="wk-header-tab wk-header-tab--item"
        [routerLink]="[currentDashboard?.Id, 'all']"
    >
        <span>{{ "AllView.All" | translate }}</span>
    </div>
    <div class="wk-header-tab wk-header-tab--filler"></div>
</div>

@if (statsVisible && !isAllView) {
    <div class="wk-header-stats">
        <div class="wk-header-stats__left-column hidden-xs hidden-sm">
            <div class="wk-header-stats__chart">
                <div class="wk-header-stats__chart-container ct-square ct-chart-pie">
                    <x-chartist [configuration]="pieChartConfiguration" />
                </div>
                <div class="wk-header-stats__chart-total">
                    <span class="wk-header-stats__chart-total-number">{{ currentTotal }}</span>
                    @if (isJobsBillingDashboard()) {
                        <div class="wk-header-stats__chart-total-label">{{ "Board.JobsAndBillingCards" | translate }}</div>
                    } @else {
                        @if (currentTotal > 1) {
                            <div class="wk-header-stats__chart-total-label">{{ "Board.Cards" | translate }}</div>
                        } @else {
                            <div class="wk-header-stats__chart-total-label">{{ "Board.Card" | translate }}</div>
                        }
                    }
                </div>
            </div>
            <div class="wk-header-stats__percentages">
                <div class="wk-header-stats__percentages-not-started">
                    <div class="wk-header-stats__percentages-color-pill"></div>
                    <div class="wk-header-stats__percentages-number">{{ currentCounters.notStarted }}</div>
                    <div class="wk-header-stats__percentages-label">
                        {{ "Dashboard.NotStarted" | translate }} ({{ countersPercentages.notStarted }}%)
                    </div>
                </div>
                <div class="wk-header-stats__percentages-active">
                    <div class="wk-header-stats__percentages-color-pill"></div>
                    <div class="wk-header-stats__percentages-number">{{ currentCounters.active }}</div>
                    <div class="wk-header-stats__percentages-label">{{ "Dashboard.Active" | translate }} ({{ countersPercentages.active }}%)</div>
                </div>
                <div class="wk-header-stats__percentages-completed">
                    <div class="wk-header-stats__percentages-color-pill"></div>
                    <div class="wk-header-stats__percentages-number">{{ currentCounters.completed }}</div>
                    <div class="wk-header-stats__percentages-label">
                        {{ "Dashboard.Completed" | translate }} ({{ countersPercentages.completed }}%)
                    </div>
                </div>
            </div>
        </div>
        @if (!isJobsBillingDashboard()) {
            <div class="wk-header-stats__compare">
                <div class="wk-header-stats__compare-year">
                    <span class="wk-header-stats__compare-label">{{ "Dashboard.ThisYear" | translate | uppercase }}</span>
                    <div class="wk-header-stats__compare-numbers">
                        @switch (cardViewService.currentViewType) {
                            @case ("notStarted") {
                                <span class="wk-header-stats__compare-number">{{ currentCounters.notStarted }}</span>
                                @if (variance.notStarted != 0) {
                                    <span class="wk-header-stats__compare-number--variance"
                                        >({{ variance.notStarted > 0 ? "+" : "" }}{{ variance.notStarted.toFixed(1) }}%)</span
                                    >
                                }
                            }
                            @case ("active") {
                                <span class="wk-header-stats__compare-number">{{ currentCounters.active }}</span>
                                @if (variance.active != 0) {
                                    <span class="wk-header-stats__compare-number--variance"
                                        >({{ variance.active > 0 ? "+" : "" }}{{ variance.active.toFixed(1) }}%)</span
                                    >
                                }
                            }
                            @case ("completed") {
                                <span class="wk-header-stats__compare-number">{{ currentCounters.completed }}</span>
                                @if (variance.completed != 0) {
                                    <span class="wk-header-stats__compare-number--variance"
                                        >({{ variance.completed > 0 ? "+" : "" }}{{ variance.completed.toFixed(1) }}%)</span
                                    >
                                }
                            }
                        }
                    </div>
                </div>
                <div [style.visibility]="showLastYear ? 'visible' : 'hidden'" class="wk-header-stats__compare-year">
                    <span class="wk-header-stats__compare-label">{{ "Dashboard.LastYear" | translate | uppercase }}</span>
                    <span class="wk-header-stats__compare-number wk-header-stats__compare-number--last-year">{{
                        lastYearCountersByState[cardViewService.currentViewType]
                    }}</span>
                </div>
            </div>
        }
        @if (showGraph) {
            <div class="wk-header-stats__at-a-glace">
                <div class="wk-header-stats__at-a-glace__labels">
                    <span class="wk-header-stats__at-a-glace-label">{{ "Dashboard.GraphSection.Atglance" | translate | uppercase }}</span>
                    <span class="wk-header-stats__at-a-glace-number">{{ "Dashboard.GraphSection.Cardsin" | translate }}</span>
                    <span class="wk-header-stats__at-a-glace-number">{{ "Dashboard.GraphSection.eachsteps" | translate }}</span>
                </div>
                <div class="wk-header-stats__at-a-glace-chart-bar" [style.width]="barChartWidth + 'px'">
                    <x-chartist [configuration]="activeBarConfiguration" />
                </div>
            </div>
        }
        <div class="wk-header-stats__alerts">
            <span class="wk-header-stats__alerts-title">{{ "Dashboard.AlertCenter.title" | translate | uppercase }}</span>
            <div class="wk-header-stats__alert">
                <icon-pds3 name="wk-icon-filled-caution" class="wk-header-stats__alert-warning-icon" />
                <span class="wk-header-stats__alert-number">
                    {{ cardsWithWarning }}
                    {{ cardsWithWarning > 1 ? ("Dashboard.AlertCenter.cards" | translate) : ("Dashboard.AlertCenter.card" | translate) }}</span
                >
                <span class="wk-header-stats__alert-label">{{ "Dashboard.AlertCenter.warning" | translate }}</span>
            </div>
            <div class="wk-header-stats__alert">
                <icon-pds3 name="wk-icon-filled-info" class="wk-header-stats__alert-alert-icon" />
                <span class="wk-header-stats__alert-number">
                    {{ cardsWithAlert }}
                    {{ cardsWithAlert > 1 ? ("Dashboard.AlertCenter.cards" | translate) : ("Dashboard.AlertCenter.card" | translate) }}</span
                >
                <span class="wk-header-stats__alert-label">{{ "Dashboard.AlertCenter.alert" | translate }}</span>
            </div>
        </div>
        @if (showLoadingStatistics || loadingCards) {
            <div class="wk-header-stats-loading">
                <app-loader text="General.LoadingStatistics" [isOverlay]="false" [size]="'medium'" />
            </div>
        }
    </div>
}
